module.exports = "<svg id=Слой_1 data-name=\"Слой 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 122 68\"> <defs> <style>.cls-3{fill:#c6c6c6}</style> </defs> <title>play_admin</title> <path class=cls-3 d=M73.07,36.13c2-1.17,2-3.09,0-4.26L55.1,21.5c-2-1.17-3.69-.21-3.69,2.13V44.37c0,2.34,1.66,3.3,3.69,2.13Z /> </svg>";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/play_admin-01.svg
// module id = ts/U
// module chunks = 3 4